import { Box } from '@mui/material';
import { useAppSelector } from '../../../../app/hooks';
import { useFeatureFlags } from '../../../../services/featureFlags/hooks/useFeatureFlags';
import { DiagnosticFeature } from '../../../commonUI/viewMode/DiagnosticFeature';
import {
  RanchPageViewEnum,
  selectRanchPageView,
} from '../../../ranches/ranchesSlice';
import { MapMarkerButton } from './components/MapMarkerButton';
import { MapMeasureToolButton } from './components/MapMeasureToolButton';
import MapSettingsButton from './components/MapSettingsButton';
import { MapZoomModeButton } from './components/MapZoomModeButton';

const MapButtons: React.FC = () => {
  const { MeasureTool } = useFeatureFlags();
  const ranchPageView = useAppSelector(selectRanchPageView);

  if (ranchPageView !== RanchPageViewEnum.blockDetail) {
    return null;
  }

  return (
    <Box
      sx={{
        position: 'absolute',
        top: '0.8rem',
        left: '1rem',
        display: 'flex',
        flexDirection: 'row',
        gap: '0.7rem',
      }}
    >
      <DiagnosticFeature>
        <MapSettingsButton />
      </DiagnosticFeature>
      {MeasureTool && <MapMeasureToolButton />}
      <DiagnosticFeature>
        <MapMarkerButton />
      </DiagnosticFeature>
      <MapZoomModeButton />
    </Box>
  );
};

export default MapButtons;
